(function () {
  new Controller('modalWrapper');
})();

(function () {
  [1, 2, 3, 4, 5, 6, 7, 8, 9].forEach((i) => {
    new Batman(`batmanModalWrapper${i}`, 'modalWrapper');
  });
})();
